<template>
  <b-dropdown
    ref="usersDropdown"
    :mobile-modal="false"
    aria-role="menu"
    position="is-bottom-left"
    class="set-user-dropdown"
  >
    <div slot="trigger">
      <button-icon
        icon="edit"
        color="is-secondary"
        outlined
      ></button-icon>
    </div>

    <b-dropdown-item
      :focusable="false"
      class="set-user-dropdown-container"
      custom
    >
      <form-field-select-record-users
        v-bind:user-ids="form.user_ids"
        v-on:user-ids-changed="form.user_ids = $event"

        v-bind:roles="form.roles"
        v-on:roles-changed="form.roles = $event"
      ></form-field-select-record-users>

      <div class="flex is-justify-content-flex-end">
        <button-default
          @click="saveUsers"
          :loading="isSaving"
          :disabled="isSaving"
        >Save Users</button-default>
      </div>

    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";
import FormFieldSelectRecordUsers from "../../../components/form/FormFieldSelectRecordUsers.vue";

export default {
  name: "SetUsers",
  components: {FormFieldSelectRecordUsers},
  props: {
    formData: {
      type: Object
    }
  },
  mixins: [FormMixin],
  data() {
    return {
      validationErrors: {},
      isSaving: false,
      form: {
        user_ids: [],
        roles: {
          lead_manager_id: null,
          acquisitions_manager_id: null,
          dispositions_manager_id: null,
          rehab_manager_id: null,
          transaction_coordinator_id: null,
        }
      },
      defaultForm: {
        user_ids: [],
        roles: {
          lead_manager_id: null,
          acquisitions_manager_id: null,
          dispositions_manager_id: null,
          rehab_manager_id: null,
          transaction_coordinator_id: null,
        }
      },
    }
  },
  created() {
      this.form = {
        user_ids: [...this.activeRecord.userIds],
        roles: {
          lead_manager_id: this.activeRecord.record.lead_manager_id,
          acquisitions_manager_id: this.activeRecord.record.acquisitions_manager_id,
          dispositions_manager_id: this.activeRecord.record.dispositions_manager_id,
          rehab_manager_id: this.activeRecord.record.rehab_manager_id,
          transaction_coordinator_id: this.activeRecord.record.transaction_coordinator_id,
        }
      }
  },
  computed: {
    activeRecord() {
      return this.$store.state.activeRecord;
    },
    authUser() {
      return this.$store.getters.authUser;
    },
  },
  methods: {
    saveUsers() {
      this.isSaving = true;
      const recordId = this.$store.state.activeRecord.record.id

      this.$api.records.changeUsers(recordId, this.form).then(() => {
        this.isSaving = false;
        this.$refs.usersDropdown.$el.click();
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.set-user-dropdown {
  ::v-deep .dropdown-menu {
    height: 100%;
    min-height: 400px;
  }

  ::v-deep .dropdown-content {
    height: 100%;
  }
}

.set-user-dropdown-container {
  min-width: 450px;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
}
</style>
